import { Injectable, inject } from '@angular/core';
import { SiteApiService } from '@core/api/site-api.service';
import { Store } from '@ngrx/store';
import { StoreInitService } from '@dashboard/dashboard-library/helpers/store-init.service';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import {
  LoadExtraVesselInfoDataAction,
  SideBarWindowTabs,
} from '@dashboard/dashboard-store';
import { RouteIds } from '@dashboard/dynamic-dashboards.route';

const VALID_TABS: SideBarWindowTabs[] = [
  'particulars',
  'graphs',
  'voyages',
  'summary',
];

@Injectable()
export class VesselInfoResolverService {
  private _sitesApi = inject(SiteApiService);
  private _storeInitHelper = inject(StoreInitService);
  private router = inject(Router);
  private _store = inject(Store);

  private lastLoadedVesselImo: string | null = null;

  resolve(route: ActivatedRouteSnapshot) {
    const tab = route.params['tab'] as SideBarWindowTabs;

    if (!VALID_TABS.includes(tab)) {
      // Redirect to default tab if invalid
      return;
    }

    // Get vesselImo from parent route
    const vesselImo = route.parent?.params[RouteIds.vesselImo];

    // Only load extra data if vesselImo changed
    if (vesselImo && vesselImo !== this.lastLoadedVesselImo) {
      this.lastLoadedVesselImo = vesselImo;
      this._store.dispatch(LoadExtraVesselInfoDataAction());
    }
  }
}
